import { ORDER_METHODS, PaymentMethods } from '../../../../../../services/exports/Constants';

export default {
  title: 'Metodi di pagamento',
  fields: {
    hidden_payment_methods: {
      label: 'Metodi di pagamento nascosti',
    },
    has_online_payments: {
      label: 'Pagamenti online abilitati',
    },
    has_paypal_upcharge: {
      label: 'Sovrapprezzo del 3,5% extra per transazioni PayPal',
    },
    has_cash_payments: {
      label: 'Pagamenti in contanti abilitati',
    },
    has_occ_cash_payments: {
      label: 'Pagamenti in contanti Call Center abilitati',
    },
    has_in_store_card_payments: {
      label: 'Pagamenti con carta in negozio abilitati',
    },
    overwrite_cash_payments_to_invoice: {
      label: 'Etichetta pagamenti in contanti come «Fattura»',
    },
  },
  payment_methods: {
    [PaymentMethods.CARD]: 'Carta',
    [PaymentMethods.PAYPAL]: 'PayPal',
    [PaymentMethods.APPLE_PAY]: 'Apple Pay',
    [PaymentMethods.GOOGLE_PAY]: 'GPay',
    [PaymentMethods.SOFORT]: 'Sofort',
    [PaymentMethods.IDEAL]: 'iDEAL | Wero',
    [PaymentMethods.BANCONTACT]: 'Bancontact',
    [PaymentMethods.EPS]: 'EPS',
    [PaymentMethods.P24]: 'Przelewy24',
    [PaymentMethods.BLIK]: 'BLIK',
    [PaymentMethods.TWINT]: 'TWINT',
    [PaymentMethods.VENMO]: 'Venmo',
    [PaymentMethods.WERO]: 'Wero',
    [PaymentMethods.KLARNA]: 'Klarna',
    [PaymentMethods.TRUSTLY]: 'Trustly',
    [PaymentMethods.PIX]: 'Pix',
    [PaymentMethods.NUPAY]: 'NuPay',
    [PaymentMethods.GIROPAY]: 'Giropay',
    [PaymentMethods.SEPA_DEBIT]: 'Addebito SEPA',
    [PaymentMethods.CASH]: 'Contanti',
    [PaymentMethods.BACS_DEBIT]: 'Addebito Bacs',
    [PaymentMethods.PAY_BY_BANK]: 'Pagamento tramite banca',
  },
  order_methods: {
    [ORDER_METHODS.pickup]: 'Ritiro',
    [ORDER_METHODS.delivery]: 'Consegna',
    [ORDER_METHODS.on_site]: 'Ordini al tavolo',
  },
  modals: {
    confirmation: {
      title: 'Sei sicuro?',
      description:
        'Una volta confermato, i pagamenti online saranno <strong>{{onlineState}}</strong>, i pagamenti in contanti saranno <strong>{{cashState}}</strong>',
    },
  },
  labels: {
    off: 'disattivati',
    on: 'attivati',
  },
  buttons: {
    save: 'Salva',
    configure_online_payments: 'Configura pagamenti online',
  },
  toasts: {
    failed_to_save_changes: 'Salvataggio modifiche non riuscito',
    changes_got_saved: 'Modifiche salvate',
  },
};
